import { logout } from '../helper/firebase';

const checkSSR = () => {
  return typeof window === 'undefined';
};
/* TOKEN SERVICE */
class TokenService {
  public key: string;

  constructor() {
    this.key = 'token';
  }

  public get = (): string | undefined => {
    if (checkSSR()) {
      return undefined;
    }

    const sessionToken = window.sessionStorage.getItem(this.key);

    if (sessionToken) {
      return sessionToken;
    }

    const token = window.localStorage.getItem(this.key);

    if (token) {
      return token;
    }

    return undefined;
  };

  public set = (token: string): void => {
    if (checkSSR()) {
      return undefined;
    }

    window.localStorage.setItem(this.key, token);
  };

  public setSessionStorage = (token: string): void => {
    if (checkSSR()) {
      return undefined;
    }

    window.sessionStorage.setItem(this.key, token);
  };

  public remove = (): void => {
    if (checkSSR()) {
      return undefined;
    }

    if (window.sessionStorage.getItem(this.key)) {
      window.sessionStorage.removeItem(this.key);
    }
    if (window.localStorage.getItem(this.key)) {
      window.localStorage.removeItem(this.key);
    }

    logout();
  };

  public isSessionStorage() {
    if (checkSSR()) {
      return undefined;
    }

    return !!window.sessionStorage.getItem(this.key);
  }
}

const TOKEN = new TokenService();

export default TOKEN;
